import { IEngineFiscalRulesState } from "@/@types/engine-fiscal-rules";
import { ColumnDef } from "@tanstack/react-table";
import { formatAsBRDateTime } from "../utils/utils";
import { DataTableColumnHeader } from "./data-table-column-header";
import { Badge } from "@chakra-ui/react";

export const columns: ColumnDef<IEngineFiscalRulesState>[] = [
  {
    accessorKey: "state_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.state_id}
      </span>
    ),
  },
  {
    accessorKey: "state",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Estado" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.state || "-"}
      </span>
    ),
  },
  {
    accessorKey: "tip",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Tipo de Tributo" />
    ),
    cell: ({ row }) => {
      const tipMap: Record<number, string> = {
        1: "ICMS",
        2: "PIS",
        3: "COFINS",
        4: "FCP",
        5: "ICMS DESONERADO",
        6: "IBS",
        7: "CBS",
      };
      return (
        <Badge
        variant="outline"
        className="text-sm font-semibold text-[#E89410] bg-orange-100 border border-orange-300 px-3 py-1 rounded-full"
      >
          {tipMap[row.original.tip] || row.original.tip}
        </Badge>
      );
    },
  },
  {
    accessorKey: "alq",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Alíquota" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {`${row.original.alq.toFixed(2).replace(".", ",")}%`}
      </span>
    ),
  },
  {
    accessorKey: "cst",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="CST" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.cst || "-"}
      </span>
    ),
  },
  {
    accessorKey: "cfop",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="CFOP" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.cfop || "-"}
      </span>
    ),
  },
  {
    accessorKey: "classification_tax",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Classificação Tributária" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.classification_tax || "-"}
      </span>
    ),
  },
  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Criado em" />
    ),
    cell: ({ row }) => {
      const date = row.getValue("created_at") as string;
      return (
        <span className="text-sm font-semibold text-gray-700">
          {date ? formatAsBRDateTime(date) : "-"}
        </span>
      );
    },
  },
  {
    accessorKey: "initial_term",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Data Inicial" />
    ),
    cell: ({ row }) => {
      const date = row.getValue("initial_term") as string;
      return (
        <span className="text-sm font-semibold text-gray-700">
          {date ? formatAsBRDateTime(date) : "-"}
        </span>
      );
    },
  },
  {
    accessorKey: "final_term",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Data Final" />
    ),
    cell: ({ row }) => {
      const date = row.getValue("final_term") as string;
      return (
        <span className="text-sm font-semibold text-gray-700">
          {date ? formatAsBRDateTime(date) : "-"}
        </span>
      );
    },
  },
  {
    id: "status",
    header: "",
    cell: ({ row }) => {
      const now = new Date();
      const initial = row.original.initial_term
        ? new Date(row.original.initial_term)
        : null;
      const final = row.original.final_term
        ? new Date(row.original.final_term)
        : null;

      if (initial && now < initial) {
        return (
          <Badge className="bg-orange-100 text-orange-800 border border-orange-300 px-3 py-1 rounded-full text-xs font-semibold">
            Programado
          </Badge>
        );
      }

      if (final && now > final) {
        return (
          <Badge className="bg-red-100 text-red-800 border border-red-300 px-3 py-1 rounded-full text-xs font-semibold">
            Expirado
          </Badge>
        );
      }

      if (initial && (!final || now <= final) && now >= initial) {
        return (
          <Badge className="bg-green-100 text-green-800 border border-green-300 px-3 py-1 rounded-full text-xs font-semibold">
            Em Vigor
          </Badge>
        );
      }

      return null;
    },
  },
];
